/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_all_our_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Všechny naše značky`
};

const da_all_our_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Alle vores mærker`
};

const de_all_our_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Alle unsere Marken`
};

const en_all_our_brands = /** @type {(inputs: {}) => string} */ () => {
	return `All our brands`
};

const es_all_our_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Todas nuestras marcas`
};

const fr_all_our_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Toutes nos marques`
};

const hu_all_our_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Összes márkánk`
};

const it_all_our_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Tutte le nostre marche`
};

const nl_all_our_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Al onze merken`
};

const pl_all_our_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Wszystkie nasze marki`
};

const pt_all_our_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Todas as nossas marcas`
};

const sv_all_our_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Alla våra varumärken`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const all_our_brands = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.all_our_brands(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("all_our_brands", locale)
	if (locale === "cs") return cs_all_our_brands(inputs)
	if (locale === "da") return da_all_our_brands(inputs)
	if (locale === "de") return de_all_our_brands(inputs)
	if (locale === "en") return en_all_our_brands(inputs)
	if (locale === "es") return es_all_our_brands(inputs)
	if (locale === "fr") return fr_all_our_brands(inputs)
	if (locale === "hu") return hu_all_our_brands(inputs)
	if (locale === "it") return it_all_our_brands(inputs)
	if (locale === "nl") return nl_all_our_brands(inputs)
	if (locale === "pl") return pl_all_our_brands(inputs)
	if (locale === "pt") return pt_all_our_brands(inputs)
	return sv_all_our_brands(inputs)
};